// Cookie size limits in bytes
const COOKIE_SIZE_WARNING_THRESHOLD = 3000
const COOKIE_SIZE_ERROR_THRESHOLD = 4000

export const getCookie = (name: string) => {
    let decodedCookie = ''

    try {
        decodedCookie = decodeURIComponent(document.cookie)
    } catch {
        return ''
    }

    const cookiesArray = decodedCookie.split(';')
    for (let cookie of cookiesArray) {
        const [cookieName, cookieValue] = cookie.trim().split('=')
        if (cookieName === name) {
            return cookieValue || ''
        }
    }

    return ''
}

export const logCookieSize = () => {
    const cookieSize = document.cookie.length

    if (cookieSize > COOKIE_SIZE_WARNING_THRESHOLD && cookieSize < COOKIE_SIZE_ERROR_THRESHOLD) {
        console.warn(`⚠️  Cookie size (${cookieSize} bytes) is approaching CloudFront limit (4KB)`)
    } else if (cookieSize > COOKIE_SIZE_ERROR_THRESHOLD) {
        console.error(`❌ Cookie size (${cookieSize} bytes) exceeds CloudFront limit (4KB)`)
    }
}
